import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useRef, useState, useCallback, useEffect } from 'react';
import { canUseDOM, areOptionsEqual, arePluginsEqual } from 'embla-carousel-reactive-utils';
import EmblaCarousel from 'embla-carousel';

function useEmblaCarousel() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var plugins = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var storedOptions = useRef(options);
  var storedPlugins = useRef(plugins);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      emblaApi = _useState2[0],
      setEmblaApi = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      viewport = _useState4[0],
      setViewport = _useState4[1];

  var reInit = useCallback(function () {
    if (emblaApi) emblaApi.reInit(storedOptions.current, storedPlugins.current);
  }, [emblaApi]);
  useEffect(function () {
    if (canUseDOM() && viewport) {
      EmblaCarousel.globalOptions = useEmblaCarousel.globalOptions;
      var newEmblaApi = EmblaCarousel(viewport, storedOptions.current, storedPlugins.current);
      setEmblaApi(newEmblaApi);
      return function () {
        return newEmblaApi.destroy();
      };
    } else {
      setEmblaApi(undefined);
    }
  }, [viewport, setEmblaApi]);
  useEffect(function () {
    if (areOptionsEqual(storedOptions.current, options)) return;
    storedOptions.current = options;
    reInit();
  }, [options, reInit]);
  useEffect(function () {
    if (arePluginsEqual(storedPlugins.current, plugins)) return;
    storedPlugins.current = plugins;
    reInit();
  }, [plugins, reInit]);
  return [setViewport, emblaApi];
}

useEmblaCarousel.globalOptions = undefined;
export { useEmblaCarousel as default };